import { useTranslation } from 'react-i18next';
import home from '../image/home.jpg';
export default function Hero() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* 背景图：欧美街拍/户外风格 */}
      <div className="absolute inset-0">
        <img
          src = {home}
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/35 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-10 py-32">
        <div className="max-w-xl">
          <p className="text-xs sm:text-sm tracking-[0.35em] text-white/55 uppercase mb-7 font-light">
            {t('hero_eyebrow')}
          </p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extralight text-white leading-[1.1] mb-8 tracking-tight">
            {t('hero_title_1')}<br />
            <span className="font-semibold italic tracking-normal">{t('hero_title_2')}</span><br />
            <span className="font-extralight">{t('hero_title_3')}</span>
          </h1>
          <div className="w-10 h-px bg-white/40 mb-8"></div>
          <p className="text-sm sm:text-base text-white/65 leading-relaxed mb-10 font-light max-w-xs sm:max-w-sm">
            {t('hero_desc')}
          </p>
          <div className="flex items-center gap-7">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-white text-[#1a1a1a] px-8 sm:px-10 py-3.5 text-xs tracking-[0.2em] uppercase font-medium hover:bg-[#f0d9b5] transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_explore')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/60 text-xs tracking-[0.2em] uppercase font-light hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_story')} →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
